// extracted by mini-css-extract-plugin
export var bold = "_rr-0";